module.exports = __webpack_public_path__ + "static/home_image-09032994bf6b596650b4e976ef378b47.jpg";